export default getConfigFromQueryParams;
function getConfigFromQueryParams(queryParams, paramName) {
  const userConfig = queryParams.get(paramName) || '';
  const y = userConfig.split('_').map(function (x) {
    return x.split(':');
  }).map(arr => ({
    [arr[0]]: arr[1]
  }));
  return Object.assign({}, ...y);
}

// externalAlignments=title:left_description:right_customButton:left_social:left&externalSection=
// &externalSections=Description:top:Title:middle
//
// &externalAlignments=title:left_description:right_customButton:left_social:left&externalSections=Description:top_Title:middle_CustomButton:top_Social:top
//# sourceMappingURL=getConfigFromQueryParams.js.map